import { RequireAuth } from '@app/core/auth/authentication/components/RequireAuth';
import { LoginPage, LogoutPage } from '@app/core/auth/flow';
import { App } from '@app/core/containers/App';
import { Route, Switch } from 'react-router-dom';

export function AppRootRoutes() {
  return (
    <Switch>
      <Route path="/login" component={LoginPage} />
      <Route path="/logout" component={LogoutPage} />
      <RequireAuth>
        <App />
      </RequireAuth>
    </Switch>
  );
}
